/* eslint-disable */
// CHANGELOG

// 03.16 Katie Garcia
// 11.18 Chris Ruzin
// Added materialboxedgallery module
import _template from 'lodash.template';

const { $ } = window;

$.fn.onewebsitegallery = function() {
  const itemSelector = '.onewebsite-gallery-item';
  const overlaySelector = '#onewebsite-gallery-overlay';
  const closeSelector = '#onewebsite-gallery-close';
  const contentClassname = 'onewebsite-gallery-content';
  const contentSelector = `.${contentClassname}`;
  const controlsClassname = 'onewebsite-gallery-controls';
  const controlsSelector = `.${controlsClassname}`;
  const templateWrapClassname = 'template-wrapper';
  const templateWrapSelector = `.${templateWrapClassname}`;
  let overlayActive = false;
  let doneAnimating = true;
  const inDuration = 350;
  const outDuration = 250;
  const imageArray = $(itemSelector);
  const placeholder = $('<div></div>').addClass('material-placeholder');
  const nextBtn = $(
    '<a href="#" class="onewebsite-gallery-btn gallery-next">Next</a>'
  );
  const prevBtn = $(
    '<a href="#" class="onewebsite-gallery-btn gallery-prev">Prev</a>'
  );
  let currGallery;
  let currImageIndex;
  let nextImageIndex;
  let nextImage;
  let prevImageIndex;
  let prevImage;

  const templateSettings = {
    interpolate: /{{([\s\S]+?)}}/g,
    escape: /{{-([\s\S]+?)}}/g,
    evaluate: /{{=([\s\S]+?)}}/g
  };

  this.each(function() {
    if ($(this).hasClass('initialized')) {
      return;
    }
    $(this).addClass('initialized');
    $(this).wrap(placeholder);
  }); //each

  /********************
   * *   TRIGGERS    * *
   *********************/
  //Open image on click
  imageArray.each(function() {
    $(this).on('click', function() {
      if ($(this).hasClass('active')) {
        closeEverything($(this));
      } else {
        openEverything($(this));
      }
      return false;
    });
  });

  // Return on ESC
  $(document).keyup(function(e) {
    if (e.keyCode === 27 && doneAnimating === true) {
      // ESC key
      if (overlayActive) {
        const currImage = getActiveImage();
        closeImage(currImage);
        removeOverlay();
        removeBtns();
      }
    }
  });

  // Return on x button click or touch
  $('body').on('touchstart', closeSelector, function() {
    $(closeSelector).trigger('click');
  });

  $('body').on('click', closeSelector, function() {
    if (overlayActive) {
      const currImage = getActiveImage();
      closeImage(currImage);
      removeOverlay();
      removeBtns();
    }
    return false;
  });

  //Advance on "next" button click
  $('body').on('click', '.gallery-next', function() {
    advanceToNext();
    return false;
  });

  //Retreat on "prev" button click
  $('body').on('click', '.gallery-prev', function() {
    retreatToPrev();
    return false;
  });

  /*****************************
   * *   Helper Functions    * *
   ******************************/
  //Advance to next
  function advanceToNext() {
    const currImage = getActiveImage();

    getCurrIndices(currImage);

    if (nextImage.length > 0) {
      closeImage(currImage, 'left');
      waitForIt(nextImage, 'right');
    } else {
      closeEverything(currImage);
    }
  }

  //Retreat to previous
  function retreatToPrev() {
    const currImage = getActiveImage();

    getCurrIndices(currImage);

    if (prevImage.length > 0 && currImageIndex >= 0) {
      closeImage(currImage, 'right');
      waitForIt(prevImage, 'left');
    } else {
      closeEverything(currImage);
    }
  }

  //waitForIt
  function waitForIt(forWhat, fromDirection) {
    if (doneAnimating === false) {
      setTimeout(function() {
        waitForIt(forWhat, fromDirection);
      }, 100);
    } else {
      openImage(forWhat, fromDirection);
    }
  } //waitForIt

  //Get Active Image
  function getActiveImage() {
    return $(`${itemSelector}.active`);
  }

  //Get Active Gallery
  function getActiveGallery(currImage) {
    return $(currImage)
      .closest('[data-gallery]')
      .data('gallery');
  }

  function closeEverything(currImage) {
    closeImage(currImage);
    removeOverlay();
    removeBtns();
  }

  function openEverything(currImage) {
    openImage(currImage);
    addOverlay();
  }

  function getBtnStatus(currImage) {
    getCurrIndices(currImage);

    if (nextImage.length <= 0) {
      nextBtn.hide();
    } else {
      nextBtn.show();
    }

    if (prevImage.length <= 0 || currImageIndex === 0) {
      prevBtn.hide();
    } else {
      prevBtn.show();
    }
  }

  function getCurrIndices(currImage) {
    currGallery = getActiveGallery(currImage);
    currImageIndex = $(`[data-gallery='${currGallery}'] ${itemSelector}`).index(
      currImage
    );
    prevImageIndex = currImageIndex - 1;
    // return an empty array if the index is negative
    prevImage =
      prevImageIndex < 0
        ? []
        : $(
            `[data-gallery='${currGallery}'] ${itemSelector}:eq(${prevImageIndex})`
          );
    nextImageIndex = currImageIndex + 1;
    nextImage = $(
      `[data-gallery='${currGallery}'] ${itemSelector}:eq(${nextImageIndex})`
    );
  }

  /*****************************
   * *   Functions    * *
   ******************************/

  function openImage(currImage, fromDirection) {
    const origin = currImage;

    if (!fromDirection) {
      fromDirection = 'right';
    }

    // Set states
    origin.addClass('active');

    // pull info from data- attributes and add them to the overlay
    // title, shortDesc, demoLink (?), thumb (img)
    const title = origin.data('title');
    const desc = origin.data('desc');
    const link = origin.data('link');
    const thumb = origin.data('thumb');
    let leftPos = 0;

    // TODO: is it possible to have the template dictate the data- names so this can be more generic?

    const $gWrap = $('<div/>')
      .addClass(`${contentClassname} container`)
      .appendTo('body');
    const $gControls = $('<div/>')
      .addClass(controlsClassname + ' full-width pos-r')
      .appendTo($gWrap);
    const $boxContent = $('<div/>')
      .addClass(templateWrapClassname)
      .appendTo($gWrap);

    const templateString = $(`#${origin.data('template')}`).val();
    const template = _template(templateString, templateSettings);
    $(
      template({ title: title, desc: desc, thumb: thumb, link: link })
    ).appendTo($boxContent);

    // hide details button if no unique link url is provided
    if (link === '/themes/') {
      $boxContent.find('.details-button').addClass('hide');
    }

    const contentWidth = $(contentSelector).width();
    if (fromDirection === 'left') {
      leftPos = (contentWidth + (window.innerWidth - contentWidth) / 2) * -1;
    } else {
      leftPos = window.innerWidth - (window.innerWidth - contentWidth) / 2;
    }

    // animate template fade-in
    $(templateWrapSelector).css({
      width: `${contentWidth}px`,
      position: 'absolute',
      left: `${leftPos}px`
    });

    $(templateWrapSelector).velocity(
      {
        left: 0
      },
      {
        duration: inDuration,
        queue: false,
        easing: 'easeOutQuad'
      }
    );

    //Swipe left and right
    $(templateWrapSelector)
      .hammer()
      .on('panend', function(e) {
        var direction = e.gesture.direction;
        if ($(overlaySelector)) {
          if (direction === 2) {
            advanceToNext();
          } else if (direction === 4) {
            retreatToPrev();
          }
        }
      });

    // Add and animate x btn
    const $xBtn = $(
      `<div id="${closeSelector.substr(
        1
      )}" class="onewebsite-gallery-btn gallery-close"></div>`
    )
      .css({
        opacity: 0,
        display: 'absolute'
      })
      .appendTo(controlsSelector)
      .velocity(
        {
          opacity: 1
        },
        {
          duration: inDuration,
          queue: false,
          easing: 'easeOutQuad'
        }
      );

    // add nav buttons and hide if necessary
    addBtns();
    getBtnStatus(origin);
  } // End openImage

  function closeImage(currImage, toDirection) {
    const origin = currImage;
    let leftPosEnd = 0;

    origin.velocity('stop', true);
    doneAnimating = false;

    const contentWidth = $(contentSelector).width();
    if (toDirection === 'left') {
      leftPosEnd = (contentWidth + (window.innerWidth - contentWidth) / 2) * -1;
    } else {
      leftPosEnd = window.innerWidth - (window.innerWidth - contentWidth) / 2;
    }

    $(templateWrapSelector)
      .velocity('stop', true)
      .velocity({ opacity: 0 });

    $(templateWrapSelector)
      .velocity('stop', true)
      .velocity(
        {
          left: `${leftPosEnd}px`
        },
        {
          duration: outDuration,
          queue: false,
          easing: 'easeOutQuad',
          complete: function() {
            origin.removeClass('active');
            $(contentSelector).remove();

            doneAnimating = true;
          } // complete
        }
      );
  } // End closeGalleryItem

  // Add overlay
  function addOverlay() {
    overlayActive = true;

    const overlay = $(`<div id="${overlaySelector.substr(1)}"></div>`)
      .css({
        opacity: 0
      })
      .click(function() {
        const currImage = getActiveImage();
        closeImage(currImage);
        removeOverlay();
        removeBtns();
      });

    // Animate Overlay
    $('body').append(overlay);
    overlay.velocity(
      {
        opacity: 1
      },
      {
        duration: inDuration,
        queue: false,
        easing: 'easeOutQuad'
      }
    );

    $('body').css('overflow', 'hidden'); // prevent scrolling on the main page content

    return overlayActive;
  } //addOverlay

  function addBtns() {
    nextBtn.css({
      opacity: 1,
      display: 'block',
      position: 'absolute',
      zIndex: 1001
    });

    prevBtn.css({
      opacity: 1,
      display: 'block',
      position: 'absolute',
      zIndex: 1001
    });

    //Animate buttons in
    $(controlsSelector).append(nextBtn);
    $(controlsSelector).append(prevBtn);
  } //addBtns

  function removeOverlay() {
    $(overlaySelector).velocity('stop', true);
    $(overlaySelector).velocity(
      {
        opacity: 0
      },
      {
        duration: outDuration,
        queue: false,
        easing: 'easeOutQuad',
        complete: function() {
          overlayActive = false;
          $(this).remove();
        }
      }
    );

    $('body').css('overflow', ''); // re-enable main page content scrolling
  } //removeOverlay

  function removeBtns() {
    nextBtn.velocity('stop', true);
    nextBtn.velocity(
      {
        opacity: 0
      },
      {
        duration: outDuration,
        queue: false,
        easing: 'easeOutQuad',
        complete: function() {
          $(this).remove();
        }
      }
    );
    prevBtn.velocity('stop', true);
    prevBtn.velocity(
      {
        opacity: 0
      },
      {
        duration: outDuration,
        queue: false,
        easing: 'easeOutQuad',
        complete: function() {
          $(this).remove();
        }
      }
    );
  } //removeBtns
};

$(document).ready(function() {
  $('.onewebsite-gallery-item').onewebsitegallery();
});
